module.exports = __webpack_public_path__ + "static/media/foto-destaque-banco-de-pedidos.9c2abd86.jpg";